import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api.js';

export default function Stories() {
  const navigate = useNavigate();
  const [stories, setStories] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.getStoriesFeed().then((r) => setStories(r?.stories || r || [])).catch(() => {});
  }, []);

  const next = () => setIdx((i) => Math.min(stories.length - 1, i + 1));
  const prev = () => setIdx((i) => Math.max(0, i - 1));

  if (!stories.length) {
    return (
      <div className="screen">
        <div className="screen-header">
          <button className="back-btn" onClick={() => navigate(-1)}>←</button>
          <h1>Stories</h1>
          <div className="spacer" />
        </div>
        <div className="empty-state">
          <div className="icon">📸</div>
          <h3>No stories yet</h3>
          <p>Be the first to post</p>
        </div>
      </div>
    );
  }

  const s = stories[idx];

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000',
        display: 'flex',
        flexDirection: 'column',
      }}
      onClick={next}
    >
      <div className="progress-pips" style={{ padding: '1rem', gap: '4px' }}>
        {stories.map((_, i) => (
          <div
            key={i}
            className={'progress-pip ' + (i < idx ? 'done' : i === idx ? 'current' : '')}
          />
        ))}
      </div>
      <div style={{ flex: 1, display: 'grid', placeItems: 'center', position: 'relative' }}>
        {s.imageUrl ? (
          <img
            src={s.imageUrl}
            alt=""
            style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        ) : (
          <div style={{ fontSize: '6rem' }}>{s.emoji || '🍻'}</div>
        )}
      </div>
      <div style={{ padding: '1.5rem' }}>
        <div style={{ fontWeight: 700, marginBottom: '0.25rem' }}>
          {s.displayName || 'Player'}
        </div>
        <div className="text-muted">{s.caption || ''}</div>
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          prev();
        }}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '30%',
          background: 'transparent',
        }}
        aria-label="Previous"
      />
      <button
        onClick={(e) => {
          e.stopPropagation();
          navigate(-1);
        }}
        style={{ position: 'absolute', top: '1rem', right: '1rem', color: '#fff', fontSize: '1.5rem' }}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
}
